import { inject, Injectable } from '@angular/core';
import { NotificationSseEventPayload } from '@api-types/sse/event-payloads/notification.sse-event-payload';
import { SseEventType } from '@api-types/sse/sse.types';
import { NotificationStateService } from '@components/notification/services/notification-state.service';
import { SseEventHandler } from '@core/sse/sse-event-handler';
import { PlannerLogStateService } from 'common/services/planner-log-state.service';

@Injectable()
export class NotificationSseHandler implements SseEventHandler<
  typeof SseEventType.Notification
> {
  private readonly notificationState = inject(NotificationStateService);
  private readonly plannerLogState = inject(PlannerLogStateService);

  readonly eventType = SseEventType.Notification;

  handle(payload: NotificationSseEventPayload): void {
    this.notificationState.addFromSse(payload);
    this.plannerLogState.addFromSseNotification(payload.referenceId);
  }
}
